import React, { useEffect, useState } from 'react';
import { Input, Button } from 'antd';
import { Alert, srcUrl } from '../../../Communal/utility';

const ExploitForm = ({ param }) => {
    const [type, setType] = useState("0"); //type: 0 添加 1 编辑
    const [error, setError] = useState({});
    const [submit, setSubmit] = useState({
        name: '',
        docs: "",
        type: '',
        link: '',
    })
    useEffect(() => {
        setType(param.match.params.type);
        if (param.match.params.id !== '0') {
            // getDetail(param.match.params.id)
        }
        document.getElementsByClassName('submit-ctf')[0].style.minHeight = 'calc(100vh - 40px)';
    }, [param]);
    let inputChange = (value, name) => {
        submit[name] = value;
        setSubmit({ ...submit })
    }
    let handleFouce = (name) => {
        error[name] = null
        setError({ ...error })
    }
    // 检索名称是否重复
    const retrievalClick = (text) => {
        if (text.replace(/(^\s*)|(\s*$)/g, "") === "") {
            Alert("warn", "请输入检索内容");
            return
        }
        // let list = {
        //     type: "vulninte",
        //     flag: text,
        //     search_type: 0
        // }
        // instance.get("/ctf/search/", { params: list }).then(data => {
        //     retrievalBox.show = true;
        //     retrievalBox.count = data.count;
        //     setRetrievalBox({ ...retrievalBox })
        // })
    }
    return (
        <div className="submit-ctf">
            <div className="banner"></div>
            <div className="content-container">
                <div className="submit-ctf-div submit-ctf-name">
                    {
                        type === "0" && "添加漏洞复现"
                    }
                    {
                        type === "1" && "编辑漏洞复现"
                    }
                </div>
                <div className="submit-ctf-div subject-info">
                    <div className="title">
                        漏洞复现基本信息
                    </div>
                    <div className="content">
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}><b>*</b>漏洞名称</span>
                            <Input
                                value={submit.name}
                                className="content-input"
                                style={{ width: 'calc(100% - 180px)' }}
                                placeholder="请输入漏洞名称"
                                onChange={(e) => inputChange(e.target.value, "name")}
                                maxLength="255"
                                onFocus={() => handleFouce("name")}
                            />
                            <span className="number">{255 - submit.name.length}</span>
                            <Button type="primary" onClick={() => retrievalClick(submit?.name)}>检索</Button>
                            <div className="error-message" style={{ marginLeft: '100px' }}>{error?.name}</div>
                        </div>
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}><b>*</b>漏洞描述</span>
                            <Input.TextArea
                                value={submit.docs}
                                className="content-input"
                                style={{ width: 'calc(100% - 180px)' }}
                                placeholder="请输入漏洞描述"
                                onChange={(e) => inputChange(e.target.value, "docs")}
                                maxLength="500"
                                onFocus={() => handleFouce("docs")}
                            />
                            <span className="number">{500 - submit.docs.length}</span>
                            <div className="error-message" style={{ marginLeft: '100px' }}>{error?.vulnbrief}</div>
                        </div>
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}>复现环境名称</span>
                            <Input
                                value={submit.type}
                                className="content-input"
                                style={{ width: 'calc(100% - 180px)' }}
                                placeholder="请输入复现环境名称"
                                onChange={(e) => inputChange(e.target.value, "type")}
                                maxLength="255"
                                onFocus={() => handleFouce("type")}
                            />
                            <span className="number">{255 - submit.type.length}</span>
                            <div className="error-message" style={{ marginLeft: '100px' }}>{error?.type}</div>
                        </div>
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}>附件</span>
                            
                            <div className="error-message" style={{ marginLeft: '100px' }}>{error?.type}</div>
                        </div>
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}><b>*</b>来源链接</span>
                            <Input
                                value={submit.link}
                                className="content-input"
                                style={{ width: 'calc(100% - 180px)' }}
                                placeholder="请输入来源链接"
                                onChange={(e) => inputChange(e.target.value, "link")}
                                maxLength="255"
                                onFocus={() => handleFouce("link")}
                            />
                            <span className="number">{255 - submit.link.length}</span>
                            <div className="error-message" style={{ marginLeft: '100px' }}>{error?.type}</div>
                        </div>
                    </div>
                </div>
                <div className="submit-ctf-div subject-info">
                    <div className="title">
                        复现手册
                    </div>
                    <div className="content">
                        <div className="retrieval-div">
                            <span style={{ width: '100px' }}><b>*</b>手册</span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ExploitForm